<template>
    <div>
        <Login v-if="main==='login'" v-on:select-main="selectMain"></Login>
        <Home v-if="main==='home'" v-on:select-main="selectMain"></Home>
        <Enter v-if="main==='asset-enter'" v-on:back="back"></Enter>
        <Deliver v-if="main==='asset-deliver'" v-on:back="back"></Deliver>
        <Move v-if="main==='asset-move'" v-on:back="back"></Move>
        <NotActive v-if="main==='asset-service'" v-on:back="back"></NotActive>
        <NotActive v-if="main==='task-waiting'" v-on:back="back"></NotActive>
        <NotActive v-if="main==='task-create'" v-on:back="back"></NotActive>
        <NotActive v-if="main==='not-active'" v-on:back="back"></NotActive>
        <Inventory v-if="main==='asset-inventory'" v-on:back="back"></Inventory>
        <History v-if="main==='history'" v-on:back="back"></History>
    </div>
</template>

<script>
import Login from './components/Login.vue'
import Home from './components/Home.vue'
import Enter from './components/Enter.vue'
import Deliver from './components/Deliver.vue'
import Move from './components/Move.vue'
import NotActive from './components/NotActive.vue'
import Inventory from './components/Inventory.vue'
import History from './components/History.vue'

export default {
    name: 'App',
    components: {
        Login,
        Home,
        Enter,
        Deliver,
        Move,
        Inventory,
        NotActive,
        History
    },
    data: function() {
        return {
            main: 'login',
        }
    },
    methods: {
        selectMain: function(item) {
            console.log(item);
            this.main = item;
        },
        back: function() {
            this.main = "home";
        }
    }
}
</script>

<style>
/* CSS goes here */
</style>
